import Tooltip from "@components/tooltip/tooltip";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

const UserComboboxDeactivatedIcon = () => {
  return (
    <Tooltip text="Deactivated">
      <span>
        <TopicflowIcon type="deactivated" className="text-gray-500 h-5 w-5" />
      </span>
    </Tooltip>
  );
};

export default UserComboboxDeactivatedIcon;
